import axios from 'axios';

import { setAlert } from './alert';
import { changeLoader } from './loader';
import { SUCURSALES } from './types';

export const buscarSucursales = (filtros = {}) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/sucursales/listar`, body, config);
        await dispatch({ type: SUCURSALES.BUSCAR, payload: res.data.sucursales });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const crearSucursal = (sucursalData) => async dispatch => {
    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/sucursales/crear`, sucursalData);
        await dispatch({ type: SUCURSALES.AGREGAR, payload: res.data.sucursal });
        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const editarSucursal = (sucursalData) => async dispatch => {
    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/sucursales/editar`, sucursalData);
        await dispatch({ type: SUCURSALES.EDITAR, payload: res.data.sucursal });
        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const eliminarSucursal = (id) => async dispatch => {
    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/sucursales/eliminar`, { id });
        await dispatch({ type: SUCURSALES.ELIMINAR, payload: id });
        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const obtenerSucursal = (id) => async dispatch => {
    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/sucursales/detalles`, { id });
        await dispatch({ type: SUCURSALES.DETALLES, payload: res.data.sucursal });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const informacionSucursal = (id) => async dispatch => {
    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/sucursales/informacion`, { id });
        await dispatch({ type: SUCURSALES.INFORMACION, payload: res.data });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const limpiarSucursal = () => dispatch => {
    dispatch({ type: SUCURSALES.LIMPIAR });
};
